import { Card, Box, Typography, Skeleton } from "@mui/material";
import SectionTitle from "../section-title";

export default function StatCard({ title, value, change, icon, loading }) {
  const InputSkeleton = () => (
    <Skeleton
      variant="rounded"
      height={26}
      animation="wave"
      sx={{
        width: "100%",
        bgcolor: "rgba(255,255,255,0.15)", // ✅ visible on dark bg
      }}
    />
  );

  return (
    <Box>
      <Card
        sx={{
          px: 2.5,
          py: 1.5,
          height: 72,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 3,
          background: "linear-gradient(135deg, #0F172A 0%, #020617 100%)",
          color: "#fff",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
        }}

      >
        {loading ? (
          <Box width="100%">
            <Skeleton
              variant="text"
              width="40%"
              sx={{ bgcolor: "rgba(255,255,255,0.25)" }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={32}
              sx={{ bgcolor: "rgba(255,255,255,0.35)" }}
            />
          </Box>
        ) : (
          <>
            {/* Left content */}
            <Box>
              <Typography variant="caption" sx={{ opacity: 0.7 }}>
                {title}
              </Typography>

              <Box display="flex" alignItems="start" gap={1}>
                <SectionTitle fontWeight={600}>
                  {value}
                </SectionTitle>
                <Typography variant="caption">
                  Total: {change}
                </Typography>
              </Box>
            </Box>

            {/* Right icon */}
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 2,
                bgcolor: "#2563EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {icon}
            </Box>
          </>
        )}

      </Card>
    </Box>
  );
}
